import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";

Vue.use(VueRouter);

const Router = new VueRouter({
  mode: "history",
  routes
});

Router.beforeEach((to, from, next) => {
  store.dispatch("auth/check");

  if (["init", "mobile"].includes(to.name)) {
    next();
  } else if (to.name === "login" && store.state.auth.authenticated) {
    next({
      name: "overview"
    });
  } else if (
    to.matched.some(m => m.meta.auth) &&
    !store.state.auth.authenticated
  ) {
    next({
      name: "login"
    });
  } else if (
    to.matched.some(m => m.meta.pageParams) &&
    !store.state.pageParams.productId
  ) {
    next({
      name: "error-page-params"
    });
  } else {
    next();
  }
});

export default Router;
